export default function () {
    return [
        {
            title: 'Main Navigation',
            items: [
                {
                    title: 'Dashboard',
                    to: '/dashboard',
                    htmlBefore: '<i class="material-icons">&#xE917;</i>',
                    htmlAfter: '',
                },
                {
                    title: 'Transactions',
                    htmlBefore: '<i class="material-icons">monetization_on</i>',
                    to: {
                        name: 'transactions',
                    },
                },
                {
                    title: 'Performance',
                    htmlBefore: '<i class="material-icons">trending_up</i>',
                    items: [
                        {
                            title: 'Advertiser',
                            to: {
                                name: 'advertisers',
                            },
                        },
                        {
                            title: 'Domains',
                            to: {
                                name: 'domains',
                            },
                        },
                        {
                            title: 'Sub-id',
                            to: {
                                name: 'sub-id',
                            },
                        },
                        {
                            title: 'Custom Sub-id',
                            to: {
                                name: 'custom-sub-id',
                            },
                        },
                        {
                            title: 'Description',
                            to: {
                                name: 'description',
                            },
                        }
                    ],
                },
                {
                    title: 'Onsite analysis',
                    htmlBefore: '<i class="material-icons">&#xe24b;</i>',
                    items: [
                        {
                            title: 'Funnel report',
                            to: {
                                name: 'funnel-report',
                            },
                        },
                        {
                            title: 'Page report',
                            to: {
                                name: 'page-report',
                            },
                        },
                    ],
                },
                {
                    title: 'Tools',
                    htmlBefore: '<i class="material-icons">handyman</i>',
                    items: [
                        {
                            title: 'UTM URL builder',
                            to: {
                                name: 'tools-utm-builder',
                            },
                        }
                    ],
                },
            ],
        },
    ];
}
